import { IExcpPmDetailsByPID } from "@redux/reducers/excipientPmReduser";

export enum ActionType {
  EXCIPIENT_PM_DETAILS_BY_PID = "EXCIPIENT_PM_DETAILS_BY_PID",
}

export interface IProjectDetailsByPid {
  type: ActionType.EXCIPIENT_PM_DETAILS_BY_PID;
  payload: IExcpPmDetailsByPID[];
}

export type Action = IProjectDetailsByPid;
